import type { ArchivedReviewReason, PsRuleHumanReviewRun } from "@/services/api/case-checking";

export function formatReviewRunWhen(iso: string): string {
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
}

const ARCHIVED_LABELS: Record<ArchivedReviewReason, string> = {
  rerun: "Before re-run",
  start_over: "Before start over",
  restore: "Before restore",
};

export function reviewRunListLabel(run: PsRuleHumanReviewRun): string {
  const title = (run.title ?? "").trim();
  if (title) return title;
  if (run.status === "saved") return "Saved copy";
  if (run.archived_reason && ARCHIVED_LABELS[run.archived_reason]) {
    return ARCHIVED_LABELS[run.archived_reason];
  }
  return formatReviewRunWhen(run.created_at);
}
